function wrapRteVideos(scope = document) {
  scope.querySelectorAll(".rte iframe").forEach((iframe) => {
    if (iframe.closest(".video-wrapper")) return;

    const src = iframe.src || "";

    if (
      src.includes("youtube") ||
      src.includes("youtu.be") ||
      src.includes("vimeo")
    ) {
      iframe.outerHTML = `<div class="video-wrapper">${iframe.outerHTML}</div>`;
    }
  });
}

document.addEventListener("DOMContentLoaded", () => wrapRteVideos());
